import { Box, Button, Container, Stack, Typography } from "@mui/material";
import React, { FC, ReactEventHandler } from "react";

import { ImageAlt } from "@/types/imageAlt";
import { LineY } from "./components";
import { Link } from "gatsby";

export const CtaSection: FC<CtaSectionProps> = ({
  backgroundImage,
  title,
  paragraph,
  cta
}) => {
  const handleClick: ReactEventHandler<HTMLAnchorElement> = event => {
    if (cta?.href) {
      event.preventDefault();
      Calendly.initPopupWidget({ url: cta.href });
    }
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: 1,
        height: "90vh",
        minHeight: 500,
        maxHeight: 1080,
        overflow: "hidden",
        background: theme => theme.palette.primary.dark
      }}
    >
      <Box
        sx={{
          zIndex: 1,
          position: "relative",
          height: 1,
          display: "flex",
          alignItems: "center"
        }}
      >
        <Container maxWidth="md" sx={{ position: "relative" }}>
          <LineY />
          <Stack alignItems="center" spacing={5}>
            <Stack alignItems="center" spacing={2}>
              <Typography
                component="h3"
                sx={{
                  color: theme => theme.palette.background.default,
                  textAlign: "center",
                  fontSize: { xs: "2rem", md: "3rem", fontWeight: 700 }
                }}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  color: theme => theme.palette.background.default,
                  lineHeight: 1.5,
                  textAlign: "center",
                  fontSize: { xs: "1.25rem", md: "1.5rem", fontWeight: 400 }
                }}
              >
                {paragraph}
              </Typography>
            </Stack>
            {!!cta?.href && !cta.to && (
              <Button
                LinkComponent="a"
                variant="contained"
                href={cta.href}
                size="large"
                onClick={handleClick}
              >
                {cta.label}
              </Button>
            )}
            {!!cta?.to && !cta.href && (
              <Link to={cta.to} style={{ textDecoration: "none" }}>
                <Button variant="contained" size="large">
                  {cta.label}
                </Button>
              </Link>
            )}
          </Stack>
        </Container>
      </Box>
      <Box
        component="img"
        {...backgroundImage}
        sx={{
          objectFit: "cover",
          filter: "brightness(0.3)",
          position: "absolute",
          zIndex: 0,
          width: 1,
          height: 1,
          inset: 0
        }}
      />
    </Box>
  );
};

export interface CtaSectionProps {
  backgroundImage?: ImageAlt;
  title?: string;
  paragraph?: string;
  cta?: { label: string; href?: string; to?: string };
}
